import Icon from '../components/Icon.vue'

Icon.register({
  'shoe-prints': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M192 160c-35.3 0-64-28.7-64-64s28.7-64 64-64h32v128h-32zM0 416c0-35.3 28.7-64 64-64h32v128h-32c-35.3 0-64-28.7-64-64zM337.5 288c90.4 0 174.5 32 174.5 96 0 45.2-39.1 97.3-148.6 120.8-32 6.9-64.9 8.5-97.6 6.2-27.3-1.9-54.1-7.8-80.3-15l-57.5-16v-128c60.2 0 79.9-15.6 104.7-32 28.6-18.9 69.8-32 104.7-32zM491.4 7.2c109.5 23.5 148.6 75.6 148.6 120.8 0 64-84.2 96-174.5 96-34.9 0-76.2-13.1-104.7-32-24.8-16.4-44.5-32-104.7-32v-128l57.5-16c26.2-7.3 53-13.1 80.3-15 32.7-2.3 65.6-0.7 97.6 6.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shoe-prints.js
// module id = 1883
// module chunks = 0